module.exports = __webpack_public_path__ + "img/logo-upcities.5f12259d.svg";